import { createSlice } from '@reduxjs/toolkit'

export const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    value: {
      test:0,
      themeLoader: "CircleLoader",
      muiTheme: {
        typography: {
          h6: {
            fontSize: "1.2em",
            // fontWeight:"bold",
          },

          fontFamily: [
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
          ].join(','),
        },
        palette: {
          mode: "light",
          primary: {
            main: '#e91e63',
            // light: will be calculated from palette.primary.main,
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
          },
          secondary: {
            main: '#9c27b0',
            light: '#ce93d8',
            // dark: will be calculated from palette.secondary.main,
            // contrastText: '#47008F',
          },
        },
        components: {
          MuiButton: {
            defaultProps: {
              size: 'small',
            },
          },
          MuiFilledInput: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiFormControl: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiFormHelperText: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiIconButton: {
            defaultProps: {
              size: 'small',
            },
          },
          MuiInputBase: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiInputLabel: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiListItem: {
            defaultProps: {
              dense: true,
            },
          },
          MuiOutlinedInput: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiFab: {
            defaultProps: {
              size: 'small',
            },
          },
          MuiTable: {
            defaultProps: {
              size: 'small',
            },
          },
          MuiTextField: {
            defaultProps: {
              margin: 'dense',
            },
          },
          MuiToolbar: {
            defaultProps: {
              variant: 'dense',
            },
          },
        },
      },
    },
  },
  reducers: {
    change: (state) => {

      state.value = {
        ...state.value

      }
    },
    test:(state, action) => {

      state.value = {
        ...state.value.test = action.payload

      }
    },


  },
})


export const { change , test} = themeSlice.actions

export default themeSlice.reducer